
import { actionTypes, ReadingMaterialInput, ReadingMaterialProps} from './actionType';
import { executeMutation, executeQuery } from 'utils/services/apiServices';
import { showSnackbar } from 'utils/snack_bar/store/action';
import { FETCH_READING_MATERIAL } from '../graphql/query';
import { CREATE_READING_MATERIAL, DELETE_READING_MATERIAL, UPDATE_READING_MATERIAL } from '../graphql/mutation';

export const fetchReadingMaterialRequest = () => ({
    type: actionTypes.FETCH_READING_MATERIALS_REQUEST
});
export const fetchReadingMaterialSuccess = (payload: ReadingMaterialProps) => ({
    type: actionTypes.FETCH_READING_MATERIALS_SUCCESS,
    payload
});
export const fetchReadingMaterialFail = (payload: string) => ({
    type: actionTypes.FETCH_READING_MATERIALS_FAIL,
    payload
});
export const fetchReadingMaterial = (video_id:string) => {
    return async (dispatch: any) => {
        try {
            const input ={
                video_id: video_id
            }
            await dispatch(fetchReadingMaterialRequest());
            const response = await executeQuery(FETCH_READING_MATERIAL, input);
            const jsonData = response.data?.fetchReadingMaterialByVideoId;
            if (jsonData?.error === null) {
                dispatch(fetchReadingMaterialSuccess(jsonData?.data.reading_material));
            } else {
                dispatch(fetchReadingMaterialFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchReadingMaterialFail('Failed to fetch Questions'));
        }
    };
};

//Create RM
export const createReadingMaterialRequest= () => ({
    type: actionTypes.CREATE_READING_MATERIAL_REQUEST
});
export const createReadingMaterialSuccess= (payload: ReadingMaterialProps) => ({
    type: actionTypes.CREATE_READING_MATERIAL_SUCCESS,
    payload
});
export const createReadingMaterialFail= (payload: string) => ({
    type: actionTypes.CREATE_READING_MATERIAL_FAIL,
    payload
});
export const createReadingMaterial = (input: ReadingMaterialInput) => {
    return async (dispatch: any) => {
        try {
             const inputData = {
                input:input
            }
            dispatch(createReadingMaterialRequest())
            const response = await executeMutation(CREATE_READING_MATERIAL, inputData);
            const jsonData = response.data?.createReadingMaterial;
            if (jsonData?.error === null) {
                dispatch(createReadingMaterialSuccess(jsonData?.data.reading_material));
                dispatch(showSnackbar('Success! Reading Material created.'));
            } else {
                dispatch(createReadingMaterialFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createReadingMaterialFail('Something went wrong, Try again later'))
        }
    };
};

//Update RM
export const updateReadingMaterialRequest= () => ({
    type: actionTypes.UPDATE_READING_MATERIAL_REQUEST
});
export const updateReadingMaterialSuccess= (payload: ReadingMaterialProps) => ({
    type: actionTypes.UPDATE_READING_MATERIAL_SUCCESS,
    payload
});
export const updateReadingMaterialFail= (payload: string) => ({
    type: actionTypes.UPDATE_READING_MATERIAL_FAIL,
    payload
});
export const updateReadingMaterial = (input: ReadingMaterialInput, materialId: string ) => {
    return async (dispatch: any) => {
        try {
             const inputData = {
                input:input,
                materialId: materialId
            }
            dispatch(updateReadingMaterialRequest())
            const response = await executeMutation(UPDATE_READING_MATERIAL, inputData);
            const jsonData = response.data?.updateReadingMaterial;
            if (jsonData?.error === null) {
                dispatch(updateReadingMaterialSuccess(jsonData?.data.reading_material));
                dispatch(showSnackbar('Success! Reading Material Updated.'));
            } else {
                dispatch(updateReadingMaterialFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateReadingMaterialFail('Something went wrong, Try again later'))
        }
    };
};


//Delete RM
export const deleteReadingMaterialRequest= () => ({
    type: actionTypes.DELETE_READING_MATERIAL_REQUEST
});
export const deleteReadingMaterialSuccess= (payload: string) => ({
    type: actionTypes.DELETE_READING_MATERIAL_SUCCESS,
    payload
});
export const deleteReadingMaterialFail= (payload: string) => ({
    type: actionTypes.DELETE_READING_MATERIAL_FAIL,
    payload
});
export const deleteReadingMaterial = (materialId: string) => {
    return async (dispatch: any) => {
        try {
             const inputData = {
                materialId:materialId
            }
            dispatch(deleteReadingMaterialRequest())
            const response = await executeMutation(DELETE_READING_MATERIAL, inputData);
            const jsonData = response.data?.deleteReadingMaterial;
            if (jsonData?.error === null) {
                dispatch(deleteReadingMaterialSuccess(materialId));
                 dispatch(showSnackbar('Success! Reading Material deleted.'));
            } else {
                dispatch(deleteReadingMaterialFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(deleteReadingMaterialFail('Something went wrong, Try again later'))
        }
    };
};
